import { FormBase } from './form-base';

export class ToggleClass extends FormBase<string> {
  controlType = 'toggle';
  checked: boolean = false;

    constructor(options: {} = {}) {
        super(options);
    }
}